/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './centerMap.less';
import StationListApi, { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import Bus, { Events } from 'src/util/bus';
import { MARK_SIZE } from 'src/pages/gis/gis';
import { getStationIcon } from 'src/components/stationTree/stationTree';
let bem = createBEM('center-map');
import json from 'src/assets/custom_map_config.json';

export interface CenterMapPropsI {
    value: string | number;
}

@Component
export default class CenterMap extends Vue.Component<{ type: number }> {
    @Prop({
        type: Number,
    })
    type!: number;
    map: any;
    setInfoWindow(marker) {
        console.log('mark', marker);
        var infoWindow = new BMapGL.InfoWindow('<div id="info-window"></div>');
        marker.addEventListener('click', function() {
            // @ts-ignore
            this.openInfoWindow(infoWindow);
            // 图片加载完毕重绘infoWindow
        });
        infoWindow.addEventListener('close', () => console.log('close'));
    }
    initMap() {
        var map = new BMapGL.Map('container');
        this.map = map;
        map.enableScrollWheelZoom(true);
        map.setMapStyleV2({
            // styleId: '484ad782347ff4404013990ecdf362ee',
            styleJson: json,
        });
    }
    @Watch('type')
    typeChange() {
        this.searchStations();
    }

    async mounted() {
        this.initMap();
        this.searchStations();
    }
    async searchStations() {
        let { code, data } = await StationListApi.searchDeviceList({ type: this.type });
        if (code !== 0) {
            return;
        }
        let t = this;
        let points: any = [];
        this.map.clearOverlays();
        let statusMap = {};
        // 创建地图实例
        data.data_info.forEach(i => {
            let point = i.location_point.split(',');
            points.push(new BMapGL.Point(point[0], point[1]));

            // var marker = new BMapGL.Marker(new BMapGL.Point(point[0], point[1]), {
            //     icon: t.getStationIcon(i),
            // });
            statusMap[i.device_status] = statusMap[i.device_status] || 0;
            statusMap[i.device_status]++;
            // this.map.addOverlay(marker);

            var label = new BMapGL.Label('', { position: new BMapGL.Point(point[0], point[1]) });
            this.map.addOverlay(label);
            label.setStyle({
                // 设置label的样式
                color: '#fff',
                width: '10px',
                height: '10px',
                // background: 'url(' + getStationIcon(data) + ')',
                border: 'none',
                // transform: `translate(-${MARK_SIZE.width}px, -${MARK_SIZE.height}px)`,
                // '-webkit-animation': 'markAnimate 0.8s infinite',
            });
        });
        Bus.$emit(Events.DeviceStatusReady, statusMap);
        // 初始化地图，设置中心点坐标和地图级别
        function setZoom(bPoints) {
            var view = t.map.getViewport(eval(bPoints));
            var mapZoom = view.zoom;
            var centerPoint = view.center;
            t.map.centerAndZoom(centerPoint, mapZoom);
        }
        setTimeout(() => {
            setZoom(points), 1000;
        });
    }
    getStationIcon(data: StationListDOI.RowDataI) {
        return new BMapGL.Icon(getStationIcon(data), new BMapGL.Size(MARK_SIZE.width, MARK_SIZE.height), {
            anchor: new BMapGL.Size(MARK_SIZE.width / 2, MARK_SIZE.height),
        });
    }
    render(h) {
        return (
            <div class={bem()}>
                <div id="container" style="height:calc(100% + 25px);width:calc(100% + 22px);margin-left: -10px" />
            </div>
        );
    }
}
